import { render } from "./TrailerCard.vue?vue&type=template&id=9aa71c28&scoped=true"
import script from "./TrailerCard.vue?vue&type=script&lang=js"
export * from "./TrailerCard.vue?vue&type=script&lang=js"

import "./TrailerCard.vue?vue&type=style&index=0&id=9aa71c28&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aa71c28"]])

export default __exports__